/**
 * Calls `onScrolledPast` (once) when the element has been visible in the viewport and then scrolled out
 * of it upwards. An element that was never visible, or that disappears without going above the viewport
 * (e.g. gets hidden), does not trigger it.
 *
 * @param {Element} $element - The element to observe.
 * @param {() => void} onScrolledPast - Called when the element has been scrolled past.
 * @param {AbortSignal} [signal] - Stops observing when aborted.
 */
export const watchElementScrolledPast = ($element: Element, onScrolledPast: () => void, signal?: AbortSignal): void => {
  let wasVisible = false

  const observer = new IntersectionObserver((entries) => {
    const { isIntersecting, boundingClientRect } = entries[entries.length - 1]

    if (isIntersecting) {
      wasVisible = true
    } else if (wasVisible && boundingClientRect.top < 0) {
      observer.disconnect()
      onScrolledPast()
    }
  })

  observer.observe($element)
  signal?.addEventListener('abort', () => observer.disconnect())
}
